import { render } from "./okr-page.vue?vue&type=template&id=bfe3527c"
import script from "./okr-page.vue?vue&type=script&lang=js"
export * from "./okr-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__